export const candidatePhone = candidate => {
  if (candidate.phone) return candidate.phone;
  const number = [candidate.phone_country_code, candidate.phone_area_code, candidate.phone_number].filter(Boolean).join(' ');
  return number && candidate.phone_suffix ? `${number} / ${candidate.phone_suffix}` : number;
};

export const canEditCandidateNote = (note, userId, now = Date.now()) => {
  const age = now - new Date(note.created_at).getTime();
  return !!userId && note.author_id != null && String(note.author_id) === String(userId) && age >= 0 && age < 60000;
};
